import "./App.css";
import React, { useState, useEffect } from "react";
import Question from "./Question";
import Score from "./Score";
import axios from "axios";

function App() {
  const [questions, setQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [score, setScore] = useState(0);
  const [showScore, setShowScore] = useState(false);
  const [selectingDifficulty, setSelectingDifficulty] = useState(true); // We need this to determine which view to show.

  const fetchQuizData = async (difficulty) => {
    try {
      const response = await axios.get(
        `https://x0jw46g3o0.execute-api.eu-west-3.amazonaws.com/DEV/questions?difficulty=${difficulty}`
      );
      setQuestions(response.data);
      setSelectingDifficulty(false); // After fetching data, the quiz should start
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleAnswerOptionClick = (answerOption) => {
    if (answerOption.isCorrect) {
      setScore(score + 1);
    }
  };

  const handleNextButtonClick = () => {
    const nextQuestion = currentQuestion + 1;
    if (nextQuestion < questions.length) {
      setCurrentQuestion(nextQuestion);
    } else {
      setShowScore(true);
    }
  };

  const startNewQuiz = () => {
    setCurrentQuestion(0);
    setScore(0);
    setSelectingDifficulty(true);
    setShowScore(false);
  };

  return (
    <div className="app container mt-5">
      {selectingDifficulty ? (
        <div>
          <h2>Select a difficulty level</h2>
          <button
            className="btn btn-primary m-2"
            onClick={() => fetchQuizData("easy")}
          >
            Easy
          </button>
          <button
            className="btn btn-primary m-2"
            onClick={() => fetchQuizData("medium")}
          >
            Medium
          </button>
          <button
            className="btn btn-primary m-2"
            onClick={() => fetchQuizData("hard")}
          >
            Hard
          </button>
        </div>
      ) : showScore ? (
        <Score score={score} onStartNewQuiz={startNewQuiz} />
      ) : (
        <Question
          question={questions[currentQuestion]}
          handleAnswerOptionClick={handleAnswerOptionClick}
          handleNextButtonClick={handleNextButtonClick}
        />
      )}
    </div>
  );
}

export default App;
